export function scoreColor (pct) {
  if (pct >= 80) return 'var(--color-success-500, #22c55e)'
  if (pct >= 60) return 'var(--color-warning-500, #f59e0b)'
  if (pct >= 30) return 'var(--color-warning-600, #d97706)'
  return 'var(--color-danger-500, #ef4444)'
}
